import { Component, Input, OnInit } from '@angular/core';
import { IVTableColumn } from '@app/directives/_layout/v-table/_models/IVTableColumn';
import { VTableService } from '@app/directives/_layout/v-table/_services/v-table.service';
import { IUnit } from '@app/interfaces/IPeripheral';
import { ISimMapping } from '@app/interfaces/ISimMapping';
import { SimMappingService } from '@app/main/modules/foundation/_services/sim-mapping.service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Observable, Subscription } from 'rxjs';
import { tap } from 'rxjs/operators';
import './sim-unit-summary.component.scss';

@UntilDestroy()
@Component({
    selector: 'sim-unit-summary',
    template: require('./sim-unit-summary.component.html')
})
export class SimUnitSummaryComponent implements OnInit {
    @Input() unit: IUnit;


    showUpdateSim: boolean;
    newSimIccid: string;
    simExists: boolean;
    validationError: string = "";

    loading: boolean;
    loadingValidation: boolean;

    simMappingHistory$: Observable<ISimMapping[]>;
    tableColumns: IVTableColumn<ISimMapping>[];

    simValidationSubscription: Subscription;

    constructor(
        private readonly simMappingService: SimMappingService,
        private readonly vTableService: VTableService) { }

    ngOnInit(): void {
        this.loadData();
    }

    onSimUpdated(): void {
        this.getSimMappingHistory();
    }

    //--

    private loadData(): void {
        this.createTable();
        this.getSimMappingHistory();
    }

    private getSimMappingHistory(): void {
        this.simMappingService.getSimMappings({ IsActive: true, Serial: this.unit.Serial }).pipe(
            untilDestroyed(this),
            tap(mappings => {
                if (!mappings.length) {
                    return;
                }

                this.simMappingHistory$ = this.simMappingService.getSimMappings({ SimId: mappings[0]?.SimId });
            })
        ).subscribe();
    }

    private createTable(): void {
        this.tableColumns = [
            {
                header: this.vTableService.createTableHeader({ tKey: 'FoundationUnits.Unit', sortable: true, width: 100, minTableWidth: 300 }),
                createCellFunction: mapping => this.vTableService.createTableCell(mapping.Serial)
            },
            {
                header: this.vTableService.createDateTableHeader({ tKey: 'Common.From' }),
                createCellFunction: mapping => this.vTableService.createDateCell(mapping.StartUtc)
            },
            {
                header: this.vTableService.createDateTableHeader({ tKey: 'Common.To' }),
                createCellFunction: mapping => this.vTableService.createDateCell(mapping.EndUtc)
            }
        ]
    }
}
